import React from "react";
import { db } from "../../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import * as XLSX from "xlsx";

function ExportContactsExcel() {
  const exportExcel = async () => {
    try {
      const q = query(collection(db, "contacts"), orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);

      const data = querySnapshot.docs.map((doc, index) => {
        const item = doc.data();

        return {
          "SL No": index + 1,
          Name: item.name || "",
          Mobile: item.mobile || "",
          City: item.city || "",
          Message: item.message || "",
          Date: item.createdAt?.toDate
            ? item.createdAt.toDate().toLocaleString()
            : "",
        };
      });

      if (data.length === 0) {
        alert("No data found!");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

      XLSX.writeFile(workbook, "contacts-data.xlsx");
    } catch (error) {
      alert("Excel export error: " + error.message);
    }
  };

  return (
    <button onClick={exportExcel} className="landmessage mt-3">
      Export Excel
    </button>
  );
}

export default ExportContactsExcel;